import React from "react";
import PropTypes from 'prop-types';

const Arrow = props => (
  <svg className={props.className} width={props.width} height={props.height} viewBox="0 0 25 14">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-115.000000, -345.000000)" fill={props.fill}>
        <g transform="translate(102.000000, 334.000000)">
          <path d="M34.7829302,19.0251263 L14,19.0251263 C13.4477153,19.0251263 13,18.577411 13,18.0251263 L13,17.9748737 C13,17.422589 13.4477153,16.9748737 14,16.9748737 L14,16.9748737 L34.7829302,16.9748737 L30.6391463,12.8310898 C30.248622,12.4405655 30.248622,11.8074006 30.6391463,11.4168763 L30.6746802,11.3813424 L30.6746802,11.3813424 C31.0652045,10.9908181 31.6983695,10.9908181 32.0888938,11.3813424 L32.0888938,11.3813424 L37.725704,17.0181526 C37.9915688,17.2840174 38.0764356,17.6623398 37.9803046,18 C38.0764356,18.3376602 37.9915688,18.7159826 37.725704,18.9818474 L32.0888938,24.6186576 C31.6983695,25.0091819 31.0652045,25.0091819 30.6746802,24.6186576 L30.6391463,24.5831237 C30.248622,24.1925994 30.248622,23.5594345 30.6391463,23.1689102 L34.7829302,19.0251263 Z"></path>
        </g>
      </g>
    </g>
  </svg>
);

Arrow.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  fill: PropTypes.string,
}

Arrow.defaultProps = {
  width: 25,
  height: 14,
  className: "",
  fill: "#FFF",
}

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/svgs/Arrow.js